import { useEffect } from 'react';

/** SPA 内 /privacy は静的HTMLへ誘導（Capacitor/iOS でも同梱ファイルを表示できる） */
export default function PrivacyPolicy() {
  useEffect(() => {
    const isLocalDev =
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      && window.location.port === '3001';
    window.location.replace(isLocalDev ? 'http://127.0.0.1:5240/privacy' : '/privacy.html');
  }, []);

  return (
    <div style={S.loading}>
      プライバシーポリシーを読み込んでいます…
    </div>
  );
}

const S = {
  loading: {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: 24,
    fontSize: 14,
    color: 'var(--text-muted)',
  },
};
